export const authTheme = {
  panelBackground: "#E8A87C",
  accent: "#f19500",
  accentHover: "#875300",
  accentActive: "#482C00",
  accentDisabled: "#FFF9EE",
  accentShadow: "0px 8px 24px rgba(245, 158, 11, 0.3)",
  accentHoverShadow: "0px 8px 24px rgba(135, 83, 0, 0.3)",
  accentActiveShadow: "0px 8px 24px rgba(72, 44, 0, 0.3)",
  accentFocusShadow: "0px 8px 24px rgba(241, 149, 0, 0.3)",
  heading: "#1B1B2F",
  muted: "#6B7280",
  inputBackground: "#F5F7FA",
  inputBorder: "#E5E7EB",
  success: "#16A34A",
};
